import styled, { keyframes } from "styled-components";

export const growIn = keyframes`
0%{transform:scale(0.1); opacity:0;}
80%{ transform:scale(1.3);opacity:0.9;}
95%{ transform:scale(0.90);opacity:1;}
100% {transform:scale(1);}
`,
  CircleAnimation = styled.div`
    padding: 0;
    margin: 0;
    z-index: 1;
    border-radius: 50%;
    animation: ${growIn} 0.35s ease-in 0s 1;
    display: flex;
  `,
  Circle = styled.div`
    padding: 0;
    margin: 0;
    box-shadow: 0 0 0 1pt
      ${({ color }) => (color === "#FFFFFF" ? "#FFFFFF" : "transparent")};
    z-index: 1;
    border: 0.75rem solid ${(props) => props.color};
    border-radius: 50%;
    @media (min-width: 600px) {
      border: 0.75rem solid ${(props) => props.color};
    }
    @media only screen and (min-width: 1000px) {
      border: 1vw solid ${(color) => color};
    }
  `,
  IconCircle = styled.div`
    padding: 0;
    margin: 0;
    display: flex;
    z-index: 1;
    justify-content: center;
    align-items: center;
    padding: 0.75rem;
    background-color: ${(props) => props.color};
    border-radius: 50%;
    overflow: hidden;
    @media only screen and (min-width: 1000px) {
      padding: 1vw;
    }
  `,
  ThinCircle = styled(Circle)`
    z-index: 1;
    padding: 0;
    margin: 0;
    border: 0.25rem solid ${({ color }) => color};
    @media (min-width: 600px) {
      border: 0.25rem solid ${(props) => props.color};
    }
    @media only screen and (min-width: 1000px) {
      border: 0.4vw solid ${(props) => props.color};
    }
  `,
  Icon = styled.img`
    padding: 0;
    margin: 0;
    background-color: ${(props) => props.color};
    height: 2rem;
    @media (min-width: 320px) {
      height: 3rem;
      
    }
    @media only screen and (min-width: 1000px) {
      
      height: 5vw;
    }
  `;
